/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidacyProfileEntryUpdatePathParams,
	CandidacyProfileEntryUpdateRequest,
	CandidacyProfileEntryUpdateResponse,
} from '../types/CandidacyProfileEntryUpdate'

/**
 * PATCH /candidate-center/organisations/:organisation/candidacies/:candidacy/profile/:section/:entry
 * @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyProfileEntryController.php CandidacyProfileEntryController::update
 */
export async function candidacyProfileEntryUpdate(
	organisation: CandidacyProfileEntryUpdatePathParams['organisation'],
	candidacy: CandidacyProfileEntryUpdatePathParams['candidacy'],
	section: CandidacyProfileEntryUpdatePathParams['section'],
	entry: CandidacyProfileEntryUpdatePathParams['entry'],
	data: CandidacyProfileEntryUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidacyProfileEntryUpdateResponse>> {
	return axiosInstance.patch(
		`/candidate-center/organisations/${organisation}/candidacies/${candidacy}/profile/${section}/${entry}`,
		data,
		config,
	)
}
